import { Layout } from 'react-admin';
import { SidebarMenu } from './sidebarMenu';

export const SidebarLayout = (props) => <Layout {...props} menu={SidebarMenu} />;